import {Directive, input, InputSignal, output, OutputEmitterRef} from "@angular/core";

/**
 * Directive to add an onActivate output to an element that fires when it is clicked, but prevents multiple clicks in quick succession
 */
@Directive({
    selector: "[woa-activatable]",
    exportAs: 'woaActivatable',
    host: {
        "(click)": "activate($event)"
    }
})
export class ActivatableDirective {

    public readonly limitClickRate: InputSignal<boolean> = input<boolean>(true);

    public onActivate: OutputEmitterRef<MouseEvent> = output<MouseEvent>();

    private lastActivationTime: number = 0;

    public activate(event: MouseEvent): boolean {
        event?.stopPropagation();
        const now: number = Date.now();
        if (this.limitClickRate() && now - this.lastActivationTime < 1000) {
            return false;
        }
        this.lastActivationTime = now;
        this.onActivate.emit(event);
        return true;
    }

    public reset(): void {
        console.log("RESET");
        this.lastActivationTime = 0;
    }
}
